import React from "react";
import { getTranslation } from "../../utils/translate.js";
import { useLanguage } from "../../utils/languageContext.js";

/**
 * OrderTabs — main scope: ongoing vs history
 */
const OrderTabs = ({ activeTab, onTabChange }) => {
    const { language } = useLanguage();

    return (
        <div className="w-full bg-white dark:bg-[#161b22] rounded-xl p-1.5 shadow-inner border dark:border-[#30363d]">
            <div className="relative flex items-stretch min-h-[2.75rem]">
                <button
                    type="button"
                    className={`relative flex-1 min-w-0 flex justify-center items-center px-2 sm:px-3 py-2.5 rounded-lg text-xs sm:text-sm font-semibold z-10 transition-all duration-200 text-center leading-tight ${
                        activeTab === "ongoing"
                            ? "text-gray-900 dark:text-[#c9d1d9]"
                            : "text-gray-700 dark:text-[#b1bac4] hover:text-gray-900 dark:hover:text-[#c9d1d9]"
                    }`}
                    onClick={() => onTabChange("ongoing")}
                >
                    <span className="whitespace-normal">{getTranslation("orderPage.ongoingOrders", language)}</span>
                </button>
                <button
                    type="button"
                    className={`relative flex-1 min-w-0 flex justify-center items-center px-2 sm:px-3 py-2.5 rounded-lg text-xs sm:text-sm font-semibold z-10 transition-all duration-200 text-center leading-tight ${
                        activeTab === "history"
                            ? "text-gray-900 dark:text-[#c9d1d9]"
                            : "text-gray-700 dark:text-[#b1bac4] hover:text-gray-900 dark:hover:text-[#c9d1d9]"
                    }`}
                    onClick={() => onTabChange("history")}
                >
                    <span className="whitespace-normal">{getTranslation("orderPage.history", language)}</span>
                </button>

                <div
                    className="absolute left-0 top-0 bottom-0 w-1/2 bg-white dark:bg-[#1c2128] rounded-lg shadow-sm transform transition-transform duration-200 ease-in-out border dark:border-[#30363d] pointer-events-none"
                    style={{
                        transform: activeTab === "history" ? "translateX(100%)" : "translateX(0)"
                    }}
                />
            </div>
        </div>
    );
};

export default OrderTabs;
